// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9041 ? "526adfa3" : chunkId) + "." + {"1418":"395170e9e39f9b59","5670":"777da3eb35b18466","9041":"f8e97eadcfe13ba7"}[chunkId] + ".js";
};